import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AbilityService } from 'ability';
import { I18NextPipe } from 'angular-i18next';
import { isEqual } from 'lodash';
import { AlertComponent, ButtonComponent, MbsPopupType, ModalComponent, ModalFooterDirective } from 'mbs-ui-kit';
import { RoutingPath } from 'mbs-ui-shared@constants';
import { StorageConnection } from 'mbs-ui-shared@models/storge-connections';
import { finalize, Observable, take } from 'rxjs';
import { CREATE_BACKUP_DESTINATION } from 'wizards/tokens/create-backup-destination.token';
import { WhereBackupStepStorageListComponent } from '../storage-list/where-backup-step-storage-list.component';

@UntilDestroy()
@Component({
  selector: 'mbs-where-backup-step-storage-list-modal',
  templateUrl: './where-backup-step-storage-list-modal.component.html',
  imports: [
    CommonModule,
    ModalComponent,
    I18NextPipe,
    ModalFooterDirective,
    WhereBackupStepStorageListComponent,
    ButtonComponent,
    AlertComponent
  ]
})
export class WhereBackupStepStorageListModalComponent implements OnInit {
  public ability = inject(AbilityService);
  public createDestinationService = inject(CREATE_BACKUP_DESTINATION, { optional: true });
  private i18nPipe = inject(I18NextPipe);

  public readonly routingPath = RoutingPath;
  public readonly mbsPopupType = MbsPopupType;
  public readonly title = `${this.i18nPipe.transform('shared:buttons.select')} ${this.i18nPipe.transform('shared:common.backupDestination')}`;

  public storages: StorageConnection[] = [];
  public selectedStorages: string[] = [];
  public disableRowTooltip: string;
  public hid: string;
  public isNBF = false;
  public isSQLPlan = false;
  public isRDMode = false;
  public canAddStorageAccount = true;

  @ViewChild(ModalComponent, { static: true }) private baseModal;

  ngOnInit() {
    this.hid = this.baseModal.data.hid;
    this.isNBF = this.baseModal.data.isNBF;
    this.isSQLPlan = this.baseModal.data.isSQLPlan;
    this.isRDMode = this.baseModal.data.isRDMode;
    this.canAddStorageAccount = this.baseModal.data.canAddStorageAccount ?? true;
    this.storages = this.baseModal.data.storages;
    this.selectedStorages = (this.baseModal.data.selectedStorages || []).filter(Boolean);
    this.disableRowTooltip = this.baseModal.data.disableRowTooltip;
  }

  public creatingDestination = false;

  public createDestination(): void {
    if (this.creatingDestination) return;

    this.creatingDestination = true;

    const created$: Observable<boolean | string | null> = this.isRDMode
      ? this.createDestinationService.openForAllCompanies()
      : this.createDestinationService.open({ hid: this.hid });

    created$
      .pipe(
        take(1),
        finalize(() => (this.creatingDestination = false))
      )
      .subscribe((created) => {
        // The opener owns the storages list, so it reloads and selects the new destination itself
        if (created) this.baseModal.save({ created: true, accountId: typeof created === 'string' ? created : null });
      });
  }

  changeSelectedHandler(selected: string[]): void {
    if (isEqual(selected, this.selectedStorages)) return;

    if (selected?.length) {
      this.baseModal.save(selected);
    }
  }
}
